import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ps-4 my-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "table table-striped"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_8 = { class: "d-block mt-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { width: "200" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "total" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "weastage_percentage"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          type: "h5",
          localizedKey: "Production Process",
          text: "Production Process"
        }),
        (_ctx.isLeather)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              class: "d-block fs_12",
              localizedKey: "(The following CO2 emissions will not be counted in the total, as they are included in leather use)",
              text: "(The following CO2 emissions will not be counted in the total, as they are included in leather use)"
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.canAddProductionProcess)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 0,
                  type: "strong",
                  localizedKey: "There are other production processes available:",
                  text: "There are other production processes available:",
                  class: "me-3"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addProductionProcess())),
              disabled: !_ctx.canAddProductionProcess
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add",
                text: "Add"
              })
            ], 8, _hoisted_4),
            (_ctx.showCopyButtons)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-tertiary ms-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copySectionFromOther')))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Copy FROM others",
                    text: "Copy FROM others"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.showCopyButtons)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-tertiary ms-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('copySectionToOther')))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Copy TO others",
                    text: "Copy TO others"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    (Object.keys(_ctx.grouped).length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials, (obj) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: "text-center",
                  key: obj.identifier
                }, [
                  _createTextVNode(_toDisplayString(obj.rawMaterial.text) + " ", 1),
                  _createElementVNode("label", _hoisted_8, _toDisplayString(obj.productionCountry.text), 1)
                ]))
              }), 128)),
              _hoisted_9
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grouped, (rawMaterialsGroup, name) => {
              return (_openBlock(), _createElementBlock("tr", { key: name }, [
                _createElementVNode("td", null, [
                  _createElementVNode("strong", null, _toDisplayString(name), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials, (material) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "text-center",
                    key: material.identifier
                  }, [
                    (rawMaterialsGroup[material.identifier])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$filters.approximation(rawMaterialsGroup[material.identifier][0].cO2e)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "--"))
                  ]))
                }), 128)),
                _createElementVNode("td", null, [
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (!_ctx.hideEditAction)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-secondary",
                              onClick: ($event: any) => (_ctx.editProductionProcess(rawMaterialsGroup, name))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Edit",
                                text: "Edit"
                              })
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary ms-1",
                          onClick: ($event: any) => (_ctx.removeProductionProcess(name))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Remove",
                            text: "Remove"
                          })
                        ], 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_15, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Total (CO2e g)",
                    text: "Total (CO2e g)"
                  })
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials, (material) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: "text-center",
                  key: material.identifier
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.co2eTotalsByMaterial[material.identifier])), 1)
                ]))
              }), 128)),
              _hoisted_16
            ]),
            (_ctx.isWeastagePercentageGSMVisible)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Wastage % GSM",
                        text: "Wastage % GSM"
                      })
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials, (material) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-center",
                      key: material.identifier
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.weastagePercentageGSMTotalsByMaterial[material.identifier])), 1)
                    ]))
                  }), 128)),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}